/**
 * mega-menu.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.saipem_popup = {
    attach: function (context, settings) {

      once('saipem-popup', '.popup', context).forEach(
        function (element) {
            $(window).scroll(function(){
                if ($(window).scrollTop() >= 100) {
                    if(!$('.popup').hasClass("popup-closed"))
                    {
                        $('.popup').show();
                    }

                }
            });
         }
      );

      once('saipem-popup-close', '.popup-close-button', context).forEach(
              function (element) {
                  $(element).click(function(){
                    $(this).closest(".popup").hide();
                     $(this).closest('.popup').addClass("popup-closed");
                  })
               }
        );
      }
  }
})(jQuery, Drupal, drupalSettings);
